import { Component, Vue} from 'vue-property-decorator';
import { LIVE_VISITS_METRICS } from './columns'
import { LIVE_CLICKS_METRICS } from '@/views/reports/pickers/base/live-clicks/columns';

@Component
export default class LivesVisitsMetricsMixin extends Vue {
  get liveVisitsMetrics(){
    let custom: { [type: string]: Bemob.MetricsHelpAggregated } = {};

    for(let i = 1; i <= 10; i++) {
      custom['reports-custom' + i] = {
        short: this.t('Name of traffic source parameter'),
        full: this.t('Additional traffic data, e.g. website ID, target ID or keyword according to the traffic source settings associated with the {0} event.',['visits'])
      }
    }

    return {
      avaliable_metrics: LIVE_VISITS_METRICS.allColumns,
      default_omit: LIVE_VISITS_METRICS.defaultUnselected,
      default_include: LIVE_VISITS_METRICS.defaultSelected,
      default_sort: LIVE_VISITS_METRICS.defaultSort,
      metrics_filters: LIVE_CLICKS_METRICS.metricsFilters,
      metrics_help: {
        //at src\views\lives\pickers\metrics-picker-dialog.vue
        'reports-timestamp': {
          short: this.t('Date and time of {0}',['visits']),
          full: this.t('Date and time of {0} when this event occurred. The data will be displayed according to the selected timezone in Settings.',['visits'])
        },
        'reports-externalid': {
          short: this.t('Unique external ID'),
          full: this.t('External ID is value of the unique visit identifier passed from traffic source to tracker.')
        },
        'campaigns-id': {
          short: this.t('Unique ID of campaign'),
          full: this.t('Unique ID of campaign associated with {0} event.',['visits'])
        },
        'campaigns-name': {
          short: this.t('Name of campaign'),
          full: this.t('Custom campaign name related to {0} event.',['visits'])
        },
        'landings-id': {
          short: this.t('Unique ID of landing page'),
          full: this.t('Unique ID of landing page associated with {0} event.',['visits'])
        },
        'landings-name': {
          short: this.t('Name of landing'),
          full: this.t('Custom name of landing page associated with {0} event.',['visits'])
        },
        'offers-id': {
          short: this.t('Unique ID of offer'),
          full: this.t('Unique ID of offer associated with {0} event.',['visits'])
        },
        'offers-name': {
          short: this.t('Offer name'),
          full: this.t('Custom name of offer related to {0} event.',['visits'])
        },
        'reports-country': {
          short: this.t('Name of the country'),
          full: this.t('Name of the country associated with {0} event.',['visits'])
        },
        'traffic_sources-id': {
          short: this.t('Unique ID of traffic source'),
          full: this.t('Unique ID of traffic source related to {0} event.',['visits'])
        },
        'traffic_sources-name': {
          short: this.t('Name of traffic source'),
          full: this.t('Name of traffic source associated with {0} event.',['visits'])
        },
        'affiliate_networks-id': {
          short: this.t('Unique ID of affiliate network'),
          full: this.t('Unique ID of affiliate network related to {0} event.',['visits'])
        },
        'affiliate_networks-name': {
          short: this.t('Name of affiliate network'),
          full: this.t('Name of affiliate network associated with {0} event.',['visits'])
        },
        'reports-os': {
          short: this.t('Operating system of device data'),
          full: this.t('Operating system of device from which the {0} was performed.',['visits'])
        },
        'reports-osversion': {
          short: this.t('Version of operating system data'),
          full: this.t('Version of operating system from which the {0} was performed.',['visits'])
        },
        'reports-devicetype': {
          short: this.t('Type of device data'),
          full: this.t('Type of device from which the {0} was performed.',['visits'])
        },
        'reports-devicevendor': {
          short: this.t('Vendor of device data'),
          full: this.t('Vendor of device from which the {0} was performed.',['visits'])
        },
        'reports-devicemodel': {
          short: this.t('Model of device data'),
          full: this.t('Model of device from which the {0} was performed.',['visits'])
        },
        'reports-browser': {
          short: this.t('Name of browser data'),
          full: this.t('Name of browser from which the {0} was performed.',['visits'])
        },
        'reports-browserversion': {
          short: this.t('Version of browser data'),
          full: this.t('Version of browser from which the {0} was performed.',['visits'])
        },
        'reports-isp': {
          short: this.t('Internet service provider data'),
          full: this.t('Internet Service Provider of device from which the {0} was performed.',['visits'])
        },
        'reports-mobilecarrier': {
          short: this.t('Mobile carrier of device data'),
          full: this.t('Mobile carrier of device from which the {0} was performed.',['visits'])
        },
        'reports-connecttype': {
          short: this.t('Connection type data'),
          full: this.t('Connection type associated with the {0}.',['visits'])
        },
        'reports-ip': {
          short: this.t('IP address'),
          full: this.t('IP address associated with the {0}.',['visits'])
        },
        'reports-referrer': {
          short: this.t('Referrer data'),
          full: this.t('Referrer associated with the {0}.',['visits'])
        },
        'reports-conversionconfirmhiddenrevenue': {
          short: this.t('Revenue of conversions with confirmed status that was not sent to the traffic source.'),
          full: this.t('Revenue of conversions with confirmed status that was not sent to the traffic source.')
        },
        'reports-conversionconfirmrevenue': {
          short: this.t('Revenue of conversions with confirmed status.'),
          full: this.t('Revenue of conversions with confirmed status.')
        },
        'reports-blacklistedip': {
          short: this.t('Shows if the corresponding click ID came from blacklisted IP address'),
          full: `${this.t('Shows if the corresponding click ID came from blacklisted IP address')}.`,
        },
        'reports-datacenterip': {
          short: this.t('Shows if the corresponding click ID came from data centres IP'),
          full: `${this.t('Shows if the corresponding click ID came from data centres IP')}.`,
        },
        'reports-id': {
          short: this.t('Unique identifier of visit'),
          full: `${this.t('Unique click ID value. This value contains 22 alpha-numeric symbols.')}`,
        },
        'live_visits-ip_with_frequent_events': {
          short: this.t('Shows if the corresponding click ID of visit is classified as frequent in terms of all incoming traffic'),
          full: `${this.t('Shows if the corresponding click ID of visit is classified as frequent in terms of all incoming traffic')}.`,
        },
        'live_visits-ip_with_frequent_campaign_events': {
          short: this.t('Shows if the corresponding click ID of visit is classified as frequent in terms of 1 ad campaign'),
          full: `${this.t('Shows if the corresponding click ID of visit is classified as frequent in terms of 1 ad campaign')}.`,
        },
        'flows-name': {
          short: this.t('Name of the flow associated to the event'),
          full: `${this.t('Name of the flow associated to the event')}.`,
        },
        'flows-id': {
          short: this.t('Unique ID of the flow associated to the event'),
          full: `${this.t('Unique ID of the flow associated to the event')}.`,
        },
        'live_reports-cost': {
          short: this.t('Cost data received in the campaign link or calculated according to your cost model for the linked campaign'),
          full: `${this.t('Cost data received in the campaign link or calculated according to your cost model for the linked campaign')}.`,
        },
        'reports-costbot': {
          short: this.t('Cost generated by bot traffic.'),
          full: this.t('Displays the cost generated by visits identified by the system as bot traffic. The value is part of the total cost, but is recorded in this separate column to help evaluate spending on bot traffic.'),
        },
        //Custom 1-10
        ...custom
      },
      metrics_options: LIVE_VISITS_METRICS.weight,
      sort_exclude: LIVE_VISITS_METRICS.sortExclude
    } as Bemob.Metrics
  }
}

